import { t } from "i18next";
import { DataTableData, DataTableHeader } from "../../../../../components/deprecated/DataTable/DataTable";

import { query, where } from "firebase/firestore";
import { ArrayUtilities } from "../../../../../utils/arrayUtilities";
import { EventData } from "../../../Event/EventData";
import { DataObjectField } from "../../DataObjectField/DataObjectField";
import { FirebaseDataDateField } from "../../DataObjectField/Generic/FirebaseDataDateField";
import { FirebaseDataNumberField } from "../../DataObjectField/Generic/FirebaseDataNumberField";
import { FirebaseDataStringField, FirebaseDataTranslationDataField } from "../../DataObjectField/Generic/FirebaseDataStringField";
import { DataObjectHelper } from "../../DataObjects/DataObjectHelper";
import { LocalData } from "../../LocalData";

export class EventDataHelper extends DataObjectHelper<EventData> {
  id = () => "events";

  title = new FirebaseDataTranslationDataField<EventData>("state", t("main.title"), (event) => event.title, "pending");

  startDate = new FirebaseDataDateField<EventData>("startDate", t("main.startDate"), (event) => event.startDate, "today");
  endDate = new FirebaseDataDateField<EventData>("endDate", t("main.endDate"), (event) => event.endDate, "event");

  price = new FirebaseDataStringField<EventData>("price", t("main.price"), (event) => event.price, "sell");
  registrationDeadline = new FirebaseDataDateField<EventData>(
    "registrationDeadline",
    t("main.registrationDeadline"),
    (event) => event.registrationDeadline,
    "pending_actions"
  );

  maxAttendees = new FirebaseDataNumberField<EventData>("maxAttendees", t("main.maximumAttendees"), (event) => event.maxAttendees);
  attendingCount = new FirebaseDataNumberField<EventData>("attendendingCount", t("main.attending"), (event) => event.attendingCount);

  allFields(): DataObjectField<any, EventData>[] {
    return [this.title, this.startDate, this.endDate, this.price, this.registrationDeadline, this.maxAttendees, this.attendingCount];
  }
  displayName(): string {
    return t("main.events");
  }
  override getAllDatas(): EventData[] {
    return LocalData.events.documents;
  }

  loadAll(): Promise<any> {
    const allEvents: EventData[] = [];
    const allPromises: Promise<any>[] = [];

    const properties = ArrayUtilities.arrayToMultiDimensional(
      LocalData.currentUser.properties.map((p) => p.id),
      10
    );

    properties.forEach((p) => {
      if (p.length === 0) return;
      const promise = new Promise<EventData[]>((resolve) => {
        LocalData.events.loadWithFilter(
          (ref) => query(ref, where("readAccess.properties", "array-contains-any", p)),
          (events) => {
            for (const event of events) {
              if (!allEvents.includes(event)) {
                allEvents.push(event);
              }
            }
            resolve(events);
          }
        );
      });
      allPromises.push(promise);
    });
    return Promise.all(allPromises);
  }

  getAllDataTableDatas(documents: EventData[]): DataTableData[] {
    return documents.map((event) => {
      return {
        key: event.id,
        cells: {
          title: event.title.translate(),
          startDate: event.startDate,
          endDate: event.endDate,
          price: event.price,
          registrationDeadline: event.registrationDeadline,
          maxAttendees: event.maxAttendees,
          attendingCount: event.attendingCount,
        },
      };
    });
  }

  getAllDataTableHeaders(): DataTableHeader[] {
    return [
      {
        key: "title",
        title: t("main.title"),
      },
      {
        key: "startDate",
        title: t("main.startDate"),
      },
      {
        key: "endDate",
        title: t("main.endDate"),
      },
      {
        key: "price",
        title: t("main.price"),
      },
      {
        key: "registrationDeadline",
        title: t("main.registrationDeadline"),
      },
      {
        key: "maxAttendees",
        title: t("main.maximumAttendees"),
      },
      {
        key: "attendingCount",
        title: t("main.attendees"),
      },
    ];
  }
}

